<template>
  <li class="accordion__item">
    <div class="default-container">
        <div
        class="accordion__trigger"
        :class="{'accordion__trigger_active': visible}"
        @click="open">
            <slot name="accordion-trigger"></slot>
        </div>
        <transition
        name="accordion"
        @enter="start"
        @after-enter="end"
        @before-leave="start"
        @after-leave="end">

        <div class="accordion__content"
            v-show="visible">
            <slot name="accordion-content"></slot>
        </div>
        </transition>
    </div>
  </li>
</template>

<script>
export default {
  props: {},
  inject: ['Accordion'],
  data () {
    return {
      index: null
    }
  },
  computed: {
    visible () {
      return this.index === this.Accordion.active
    }
  },
  methods: {
    open () {
      if (this.visible) {
        this.Accordion.active = null
      } else {
        this.Accordion.active = this.index
      }
    },
    start (el) {
      el.style.height = el.scrollHeight + 'px'
    },
    end (el) {
      el.style.height = ''
    }
  },
  created () {
    this.index = this.Accordion.count++
  }
}
</script>

<style lang="scss" scoped>
.accordion__item {
  cursor: pointer;
  position: relative;
}

.accordion__trigger {
  display: flex;
  justify-content: space-between;
  &:after{
    content: "";
    position: absolute;
    right: 0;
    top: 50%;
    transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 0);
    background-image: url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='17' height='17' viewBox='0 0 17 17'%3E%3Cg id='Icon_feather-arrow-right_2' data-name='Icon feather-arrow-right 2' transform='translate(15.644 1) rotate(90)'%3E%3Cpath id='Unione_1' data-name='Unione 1' d='M7.977 16.784a.738.738 0 0 1 0-1.046l6.5-6.5H.738a.739.739 0 0 1 0-1.478H14.476l-6.5-6.5A.739.739 0 1 1 9.021.217l7.761 7.76a.739.739 0 0 1 .136.186h0l.007.015v0l.006.013v0l.006.013 0 0 0 .011 0 .007 0 .01 0 .008 0 .008 0 .01 0 .007 0 .01 0 .007 0 .011v.005l0 .012v.005l0 .012v.006l0 .012v.006l0 .012V8.38l0 .011v.027s0 .005 0 .008v.018s0 .009 0 .013 0 0 0 0 0 .011 0 .017v0c0 .006 0 .012 0 .019h0s0 .007 0 .01a.069.069 0 0 1 0 .007.736.736 0 0 1-.232.521L9.021 16.784a.74.74 0 0 1-1.044 0Z' transform='translate(-1 -1.356)' fill='%23343434'/%3E%3C/g%3E%3C/svg%3E");
    width: 17px;
    height: 17px;
  }
  &.accordion__trigger_active:after{
    transform: translate3d(0, -50%, 0) rotate3d(0, 0, 1, 180deg);
  }
}

.accordion-enter-active,
.accordion-leave-active {
  will-change: height, opacity;
  transition: height 0.3s ease, opacity 0.3s ease;
  overflow: hidden;
}

.accordion-enter,
.accordion-leave-to {
  height: 0 !important;
  opacity: 0;
}
</style>
